import { DishIcon, HomeIcon, ProfileCartIcon } from "../../../../../../../Components/IconComponents";
import useLanguagesHooks from "../../../../../../../Components/Languages/setLanguage-hooks";
import { IVisitorNavItem } from "../../../../../../../Interfaces/componentTypes";
import { VisitorPageContents } from "../../../../visitorPage";
import { IFooterProps } from "./footer";

const useByteFooter = (props:IFooterProps) => {
    const {contentType,is_user,setContentType} = props;
    const { t } = useLanguagesHooks();

    const onHandleNav = (type: VisitorPageContents) => {
        const currentUrl = window.location.href.split('?')[0];
        window.history.pushState({}, '', `${currentUrl}?tab=${type}`);
        setContentType(type)
    };
    const footerNavItems: IVisitorNavItem[] = [
        {
            id: VisitorPageContents.PROFILE,
            title: t('My_Business.Home'),
            onClick: () => onHandleNav(VisitorPageContents.PROFILE),
            icon:
            <HomeIcon width={25} height={25}
             color={contentType === VisitorPageContents.PROFILE ? 'var(--primary-hover)' : 'var(--input-label)'}
             />
        },
        {
            id: VisitorPageContents.MENU,
            title: t('My_Business.Menu'),
            onClick: () => onHandleNav(VisitorPageContents.MENU),
            icon:
            <DishIcon width={25} height={25}
             color={contentType === VisitorPageContents.MENU ? 'var(--primary-hover)' : 'var(--input-label)'}
             />
        },
    ];

    if (is_user) {
    footerNavItems.splice(1, 0, {
    id: VisitorPageContents.MY_ORDERS,
    title: t('Visitor.My_Orders'),
    onClick: () => onHandleNav(VisitorPageContents.MY_ORDERS),
    icon: (
      <ProfileCartIcon
        width={25}
        height={25}
        color={
          contentType === VisitorPageContents.MY_ORDERS
            ? 'var(--primary-hover)'
            : 'var(--input-label)'
        }
      />
    ),
  });
};

    return {
        footerNavItems
    }
};

export default useByteFooter